<template>
  <div>

    <el-row :gutter="20">
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="用户"
                      label-width="70px">
          <el-input v-model="keyword"
                    clearable
                    placeholder="手机号/真实姓名/用户"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="getUserList()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>

          <el-table v-loading="tableLoading"
                    :data="userPageInfo.records"
                    sortable="custom"
                    @sort-change="tableSort"
                    :default-sort="{prop: 'createTime', order: 'descending'}"
                    style="width: 100%">

            <el-table-column prop="loginName"
                             label="用户">
            </el-table-column>
            <el-table-column prop="userName"
                             label="真实姓名">
            </el-table-column>
            <el-table-column prop="mobilePhone"
                             label="手机号">
            </el-table-column>
            <el-table-column prop="createTime"
                             sortable
                             label="创建时间">
            </el-table-column>
            <el-table-column prop="reportCount"
                             label="已生成报告数量">
            </el-table-column>
            <el-table-column label="帐号状态"
                             prop="userStatus">

            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">

                <el-button type="text"
                           @click="searchReport(scope.row)"
                           size="small">查看生成报告</el-button>

              </template>

            </el-table-column>
          </el-table>

        </el-row>
        <el-row>
          <br>
          <el-pagination background
                         @current-change="getUserList"
                         layout="prev, pager, next,total"
                         :current-page="userPageInfo.current"
                         :page-size="userPageInfo.size"
                         :total="userPageInfo.total">
          </el-pagination>

        </el-row>
      </el-col>

    </el-row>

  </div>
</template>

<script>

import moment from 'moment'
export default {
  name: 'myReports',

  data: function () {
    return {
      tableLoading: true,
      keyword: '',
      userPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1,
        prop: 'createTime',
        order: 'descending'
      }

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    statusFilter: function (v) {
      switch (v) {
        case 1:
          return '生效'
        case 0:
          return '无效'
        default:
          return v
      }
    },
    typeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '股票'
        case 'CONCEPT':
          return '概念'
      }
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'HKSTOCK':
          return '港股报告'
        default:
          break
      }
      return v
    },

    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {
    tableSort (col) {
      this.userPageInfo.prop = col.prop || ''
      this.userPageInfo.order = col.order || ''
      this.getUserList()
    },
    searchReport (row) {
      this.$emit('searchReport', row.loginName)
    },

    getUserList () {
      let page = this.userPageInfo.page || 1
      let _this = this
      this.axios.get(`/api/web/csmarUser/getorguserlist?page=${page}&pageSize=10&keyword=${this.keyword}&prop=${this.userPageInfo.prop}&order=${this.userPageInfo.order}`).then(resp => {
        _this.tableLoading = false
        _this.userPageInfo.records = resp.data.data
        _this.userPageInfo.total = parseInt(resp.data.total)
      })
    }
  },
  components: {

  },
  mounted () {
    this.getUserList(1)
  },
  computed: {
    orgId: function () {
      return this.$store.state.orgId
    }
  },
  watch: {
    orgId: function () {
      console.log('切换了orgId---user' + this.orgId)
      this.getUserList(1)
    }
  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/biz/user.vue